<template>
  <v-dialog
    v-model="show"
    max-width="640px"
    @click:outside="cancel"
  >
    <v-card class="pa-sm-8 pa-4">
      <v-card-title class="text-h6 pa-0 mb-1">
        Новый сотрудник
      </v-card-title>
      <v-card-subtitle class="pa-0 mb-6">
        Логин и пароль сотрудник получает от вас, роль определяет доступные разделы
      </v-card-subtitle>

      <v-card-text class="pa-0">
        <v-form
          ref="form"
          class="multi-col-validation"
        >
          <div class="text-subtitle-2 mb-3">
            Кто это
          </div>
          <v-row dense>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="lastName"
                outlined
                dense
                hide-details="auto"
                label="Фамилия"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="firstName"
                outlined
                dense
                hide-details="auto"
                label="Имя"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="patronymic"
                outlined
                dense
                hide-details="auto"
                label="Отчество"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-6"></v-divider>

          <div class="text-subtitle-2 mb-3">
            Доступ
          </div>
          <v-row dense>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="userName"
                :rules="[rules.required]"
                outlined
                :error="hasErrorsForProperty(errors.errors, 'userName')"
                :error-messages="errorMessages(errors.errors, 'userName')"
                dense
                hide-details="auto"
                label="Логин"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-text-field
                v-model="email"
                :rules="[rules.emailValidator]"
                outlined
                dense
                hide-details="auto"
                label="Почта"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-select
                v-model="role"
                :items="rolesDropdown"
                :rules="[rules.required]"
                outlined
                dense
                hide-details="auto"
                label="Роль"
              ></v-select>
            </v-col>
          </v-row>

          <v-divider class="my-6"></v-divider>

          <div class="text-subtitle-2 mb-3">
            Пароль
          </div>
          <v-row dense>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="password"
                :rules="[rules.required, rules.passwordValidator]"
                outlined
                dense
                hide-details="auto"
                :type="isPasswordVisible ? 'text' : 'password'"
                :append-icon="isPasswordVisible ? icons.mdiEyeOutline : icons.mdiEyeOffOutline"
                label="Пароль"
                @click:append="isPasswordVisible = !isPasswordVisible"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="confirmPassword"
                :rules="[rules.required, rules.confirmedValidator(confirmPassword, password)]"
                outlined
                dense
                hide-details="auto"
                :type="isCPasswordVisible ? 'text' : 'password'"
                :append-icon="isCPasswordVisible ? icons.mdiEyeOutline : icons.mdiEyeOffOutline"
                label="Подтверждение пароля"
                @click:append="isCPasswordVisible = !isCPasswordVisible"
              ></v-text-field>
            </v-col>
          </v-row>

          <p class="text--secondary text-sm mt-3 mb-0">
            Не меньше восьми знаков, из них строчная и прописная буквы, цифра и знак препинания.
            Позже пароль можно сменить кнопкой в списке сотрудников.
          </p>
        </v-form>
      </v-card-text>

      <v-card-actions class="pa-0 mt-6">
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          outlined
          type="reset"
          @click="cancel"
        >
          Отмена
        </v-btn>
        <v-btn
          color="primary"
          :loading="saving"
          @click="saveData"
        >
          Создать
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
 mdiCheck, mdiClose, mdiLockOutline, mdiEyeOutline, mdiEyeOffOutline,
} from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { rules } from '@/helpers/validation'
import { errorMessages, hasErrorsForProperty } from '@/helpers'

export default {
  name: 'UserForm',
  props: ['show', 'cancellation'],
  data: () => ({
    icons: {
      mdiCheck,
      mdiClose,
      mdiLockOutline,
      mdiEyeOutline,
      mdiEyeOffOutline,
    },
    rules,
    hasErrorsForProperty,
    errorMessages,
    isCPasswordVisible: false,
    isPasswordVisible: false,
    saving: false,
  }),
  computed: {
    ...mapFormHandlers('user/form', [
      'userName',
      'email',
      'firstName',
      'role',
      'lastName',
      'patronymic',
      'password',
      'confirmPassword',
      'errors',
    ]),
    ...mapGetters('dictionary', { rolesDropdown: 'rolesDropdown' }),
  },
  watch: {
    show(newValue) {
      if (newValue && this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
  },
  async mounted() {
    await this.fetchRoles()
  },
  methods: {
    cancel() {
      this.resetForm()
      this.cancellation()
    },
    ...mapActions('user/form', ['resetForm', 'create']),
    ...mapActions('dictionary', { fetchRoles: 'fetchRoles' }),
    async saveData() {
      if (!this.$refs.form.validate()) return

      this.saving = true
      try {
        await this.create()
        this.resetForm()
        this.cancellation()
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
